import { jsx as _jsx } from "react/jsx-runtime";
import { assertNever } from "@msys/common";
import { useFormatting } from "../formatting/useFormatting.js";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledSpecializedValue = ({ label, value, unit = "", type, multiplier = 1, align, icon, notSetText, ...props }) => {
    const { getFormattedInteger, getFormattedFloat, getFormattedPrice } = useFormatting();
    const getFormattedUnit = (value, unit) => {
        return `${value}${unit || ""}`.trim();
    };
    const getFormattedValue = (value, unit, multiplier, type) => {
        switch (type) {
            case "integer":
                return getFormattedUnit(getFormattedInteger(value * multiplier), unit);
            case "float":
                return getFormattedUnit(getFormattedFloat(value * multiplier), unit);
            case "price":
                return getFormattedPrice(value);
            case "money":
                return getFormattedPrice(value ? value.amount : 0);
            default:
                assertNever(type);
        }
    };
    const formattedValue = getFormattedValue(value, unit, multiplier, type);
    return (_jsx(LabeledValue, { label: label, align: align, icon: icon, notSet: !formattedValue, ...props, children: formattedValue || notSetText }));
};
//# sourceMappingURL=LabeledSpecializedValue.js.map